import styled from "../_snowpack/pkg/@emotion/styled.js";
import {t} from "../common/i18n.js";
import React from "../_snowpack/pkg/react.js";
import {colors, fontFamily, lineHeight, media} from "./theme.js";
import {formatCurrency} from "../common/universal.js";
import Stack from "./stack.js";
import Inline from "./inline.js";
import Image from "./image.js";
import {withAttrs} from "../common/utils.js";
import {CheckGreen, GrayCircle} from "./icons.js";
export default function ProductOption(props) {
  const {article, option, quantity, selected, readOnly, prices, ...rest} = props;
  const unit = option.unit ? option.unit : t("Stück");
  const {name, image, description, order_factor = 1} = option;
  const optionQuantity = quantity * order_factor;
  const price = prices?.price || article.gross_price;
  return /* @__PURE__ */ React.createElement(Container, {
    selected: !!selected,
    readonly: readOnly,
    ...rest
  }, /* @__PURE__ */ React.createElement(TitleContainer, null, /* @__PURE__ */ React.createElement(Title, null, name), /* @__PURE__ */ React.createElement(Price, null, optionQuantity, " ", unit, " ", t("für"), " ", price ? formatCurrency(price) : "-")), /* @__PURE__ */ React.createElement(InnerContainer, null, /* @__PURE__ */ React.createElement(Img, {
    ...image
  }), !readOnly && /* @__PURE__ */ React.createElement(Description, null, description)), !readOnly && /* @__PURE__ */ React.createElement(SuccessContainer, null, selected ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CheckGreen, null), " ", t("Zum Warenkorb hinzugefügt")) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(GrayCircle, null), " ", t("Zum Warenkorb hinzufügen"))));
}
const Container = styled(Stack)`
  background: white;
  border: 1px solid ${colors.b5};
  border-radius: 4px;
  padding: 16px;

  ${({selected}) => selected && `
      background: ${colors.c3};
      border-color: ${colors.c1};
    `}

  ${({readonly}) => readonly && `
      border: 0 none;
      display: flex;
      flex-direction: row-reverse;
      align-items: center;

      img {
        width: 24px;
        height: 24px;
      }
    `}
`;
const SuccessContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: bold;

  svg {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
`;
const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
const Title = styled.div`
  font-family: ${fontFamily.primary};
  font-weight: bold;
  font-size: 16px;
  line-height: ${lineHeight};
`;
const Price = styled.div`
  font-family: ${fontFamily.primary};
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  margin-left: 30px;
  white-space: nowrap;

  ${media.phone} {
    display: none;
  }
`;
const InnerContainer = styled(Inline)``;
const Img = styled(withAttrs(Image, {sizes: [[68, 68]]}))`
  border-radius: 100%;
  width: 68px;
  height: 68px;
  object-fit: cover;
`;
const Description = styled.div`
  font-family: ${fontFamily.primary};
  font-size: 14px;
  line-height: 22px;
`;
